import React, { useEffect, useRef, useState } from "react";
import { BitmovinPlayer } from "bitmovin-player-react";

import Header from '../authentication/Header';
import Footer from '../authentication/Footer';
import Loader from '../Loader';
import { removeSpecialCharecters, location } from '../../utils/utils';
import axios from 'axios'

const playerSource = {
  hls: "https://cdn.bitmovin.com/content/assets/streams-sample-video/sintel/m3u8/index.m3u8",
};

export default function AutoPlayChannel() {
  const playerRef = useRef(null);
  const [loader, setloader] = useState(true);
  const [playerConfig, setplayerConfig] = useState({});
  const [playerSource, setplayerSource] = useState({});

  let channelParam = location("channel");
  let menusParam = location("menus");
  let isFullPageMode = (channelParam === 'fullscreen' || channelParam === 'fullscreeen') && menusParam === 'false';

  console.log('isFullPageMode ', isFullPageMode)



  useEffect(() => {
    let siteSettings = window.site;
    let appSettings = window.app
    let siteConfig = (siteSettings && siteSettings.config) || (appSettings && appSettings.defaultSiteSettings && appSettings.defaultSiteSettings.config);
    let bitmovinSettings = (siteConfig.player || {}).bitmovin || {};
    let playerKey = bitmovinSettings.playerKey;
    let screeningConfig = siteConfig.screening || {};
    let autoPlayConfig = screeningConfig.autoPlay || {};
    let channelCode = (autoPlayConfig.channel && autoPlayConfig.channel.channelCode) || 5001;
    let appName = window.app.storage.getItem('appName');
    if (appName == "kyliejenner" || appName == "kardashiancareers") {
      channelCode = 5011
    } else if (appName == "paff") {
      channelCode = 5057
    }
    let screeningApi = siteConfig?.screeningApi

    console.log('screeningApi ', siteConfig, screeningApi)

    let playerConfig = {
      "key": playerKey,
      playback: {
        autoplay: true,
        muted: siteConfig.player.playerMute || false
      },
      adaptation: {
        desktop: {
          preload: true
        },
        mobile: {
          preload: true
        }
      }
    };

    setplayerConfig(playerConfig)

    fetchPlaylist(screeningApi, channelCode, appName);

  }, [window.site])
  const handleMouseEnter = () => {
    const p = playerRef.current;
    if (p && !p.isPlaying()) p.play();
  };

  const handleMouseLeave = () => {
    const p = playerRef.current;
    if (p && p.isPlaying()) p.pause();
  };

  const fetchPlaylist = async (screeningApi, channelCode, appName) => {

    const apiUrl = `${screeningApi}/channelAssets?appname=${appName}&env=dev&&playbackUrls=true&channelcode=${channelCode}`;

    try {
      const response = await axios(apiUrl, {
        method: "POST",
        headers: { Accept: "application/json, text/plain, */*" },
      });

      console.log("✅ API Response:", response);
      setloader(false)
      const m3u8Url = response?.data?.result?.[0]?.url || {};
      if (m3u8Url) {

        setplayerSource({
          hls: m3u8Url,
          title: response?.data?.result?.[0]?.channelname
        });
      }
      else console.error("❌ No M3U8 URL found in API response");
    } catch (err) {
      console.error("❌ Error fetching playlist:", err);
    }
  }



  if (loader == true) {
    return (<div>
      <div className="carousel_blk">
        <Loader />
      </div>
    </div>);
  }
  else {



    if (isFullPageMode) {
      return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', background: '#000', zIndex: 9999 }}>
          <style>{`
            .bitmovinplayer-container {
              position: inherit !important;
              height: 100dvh !important;
            }
            .bmpui-ui-uicontainer {
              height: 100dvh !important;
            }
            .bmpui-ui-controlbar {
              position: fixed !important;
              bottom: 0 !important;
              left: 0 !important;
              right: 0 !important;
              z-index: 10000 !important;
            }
            @media screen and (max-width: 900px) and (orientation: landscape) {
              .bitmovinplayer-container {
                height: 100svh !important;
                max-height: -webkit-fill-available !important;
              }
              .bmpui-ui-uicontainer {
                height: 100svh !important;
              }
            }
          `}</style>
          <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {playerSource?.hls ? (
              <BitmovinPlayer
                playerRef={playerRef}
                config={playerConfig}
                source={playerSource}
              />
            ) : (
              <div className="carousel_blk"><Loader /></div>
            )}
          </div>
        </div>
      );
    }

    return (
      <div>

        <Header />

        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <style>{`
                            @media (min-width: 801px) {
                                .bitmovinplayer-container {
                                    height: 98vh !important;
                                }
                            }
                        `}</style>
          {playerSource?.hls ? (
            <BitmovinPlayer
              playerRef={playerRef}
              config={playerConfig}
              source={playerSource}
            />
          ) : (
            <div className="carousel_blk"><Loader /></div>
          )}
        </div>
        <Footer />
      </div>
    );
  }


}
